// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3Djwr","empty":"ModalGraph_empty__1kH3q"};